<template>
  <div class="row-box">
    <WrapperField
      v-for="(value, index) in data"
      :key="value + index"
      :data="
        createDataField({
          fieldName: index,
          fieldValue: value,
          fieldGroup: FieldGroup.STORAGE_ISSUE_DETAILS,
        })
      "
    ></WrapperField>
  </div>
</template>

<script>
import { createDataField } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';
import { FieldGroup } from '@/utils/fullStatementView';
import { formattingStorageFileIdsValue } from '@/utils/common';

export default {
  name: 'Step2',
  components: { WrapperField },
  props: ['data'],
  created() {
    delete this.data.note;
    delete this.data.hasPrivilege;
    this.data.storageFileId = formattingStorageFileIdsValue(
      this.data.storageFileId,
      true
    );
  },
  data: () => ({
    createDataField,
    FieldGroup,
  }),
  methods: {},
};
</script>
